import { createPaginatedSlice } from "../../helpers/reduxHelper";

const collectionList = createPaginatedSlice('collectionList');

export const collectionListActions = collectionList.actions
export const collectionListSelector = state => state.collectionList;
export const collectionListReducer = collectionList.reducer;
export default collectionListReducer

export const collectionListSelectors = collectionList.LF.selectors